import { render, staticRenderFns } from "./LocationAdvisoryComponent.vue?vue&type=template&id=3c4d92ba&scoped=true&"
import script from "./LocationAdvisoryComponent.vue?vue&type=script&lang=ts&"
export * from "./LocationAdvisoryComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LocationAdvisoryComponent.vue?vue&type=style&index=0&id=3c4d92ba&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4d92ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VContainer,VIcon,VRow,VTooltip})
